[
    {
        "display": "true",
        "ui_columnname": "Action",
        "db_columnname": "action",
        "datatype": "String",
        "mappingkey": "action",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "CATReporterIMID",
        "db_columnname": "CATReporterIMID",
        "datatype": "String",
        "mappingkey": "CATReporterIMID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Report Date",
        "db_columnname": "reportdate",
        "datatype": "String",
        "mappingkey": "reportdate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display":"true",
        "ui_columnname":"Application",
        "db_columnname":"application",
        "datatype":"String",
        "mappingkey":"application",
        "dropdown":"NO",
        "isdefault": "false",
        "disabled":"true",
        "value":"",
        "dropdowntype": "singleselect",
        "dropdownvalue":""
    },
    {
        "display": "true",
        "ui_columnname": "User Action",
        "db_columnname": "action",
        "datatype": "String",
        "mappingkey": "action",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "UpdatedUser",
        "db_columnname": "updatedUser",
        "datatype": "String",
        "mappingkey": "updatedUser",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Datetimestamp",
        "db_columnname": "lastUpdate",
        "datatype": "String",
        "mappingkey": "lastUpdate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Received FDID",
        "db_columnname": "receivedFDID",
        "datatype": "String",
        "mappingkey": "receivedFDID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    }, 
    {
        "display": "true",
        "ui_columnname": "Account Number",
        "db_columnname": "accountNumber",
        "datatype": "String",
        "mappingkey": "accountNumber",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Customer Record ID",
        "db_columnname": "customerRecordID",
        "datatype": "String",
        "mappingkey": "customerRecordID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "In Customer Record ID",
        "db_columnname": "inCustomerRecordID",
        "datatype": "String",
        "mappingkey": "inCustomerRecordID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Exception code",
        "db_columnname": "failureCode",
        "datatype": "String",
        "mappingkey": "failureCode",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display":"true",
        "ui_columnname":"Activity",
        "db_columnname":"activity",
        "datatype":"String",
        "mappingkey":"activity",
        "dropdown":"NO",
        "isdefault": "false",
        "disabled":"false",
        "value":"",
        "dropdowntype": "singleselect",
        "dropdownvalue":""
    },
    {
        "display": "true",
        "ui_columnname": "Audit",
        "db_columnname": "audit",
        "datatype": "String",
        "mappingkey": "audit",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Original JSON",
        "db_columnname": "originalJSON",
        "datatype": "String",
        "mappingkey": "originalJSON",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "JSON",
        "db_columnname": "updatedJSON",
        "datatype": "String",
        "mappingkey": "updatedJSON",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    }
]